const MQTT_MODE = {
  LOCAL: 'local',
  EXTERNAL: 'external'
};

const SETUP_MODES = {
  LOCAL: 'local',
  REMOTE: 'remote'
};

export { MQTT_MODE, SETUP_MODES };
